export default "__VITE_ASSET__BDc4dzxj__"